import RFIInfantMeatsProduct from 'models/RFIInfantMeatsProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import RFIInfantMeatsPackage from './RFIInfantMeatsPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { getRFIInfantMeatsCategories } from './Utilities'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc
      initialBrandNameOptions={[
        { label: 'Brand Name', value: '', isDisabled: true },
      ]}
      updateBrandNameOptions={getRFIInfantMeatsCategories}
    />
  ),
  packagingInfo: <RFIInfantMeatsPackage />,
  productTitle: '2025 RFI Brand Specific Infant Meats',
  model: RFIInfantMeatsProduct,
  validCategories: ['13'],
  validSubCategories: ['001RFI', '101RFI'],
  brandSpecific: true,
}

const RFIInfantMeats = () => <ProductForm product={productOptions} />

export default RFIInfantMeats
